import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_setting_panel_kamoku_list = _resolveComponent("setting-panel-kamoku-list")!
  const _component_setting_panel_buttons = _resolveComponent("setting-panel-buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_setting_panel_kamoku_list, {
        class: "col-5",
        "kamoku-list": _ctx.responseSettingItem.targets,
        "selected-kamoku": _ctx.state.selectedTargetItem,
        onSelectedRow: _ctx.selectedTargetItem
      }, null, 8, ["kamoku-list", "selected-kamoku", "onSelectedRow"]),
      _createVNode(_component_setting_panel_buttons, {
        class: "col-2",
        "can-add": _ctx.selectedSourceItem !== null,
        "can-remove": _ctx.selectedTargetItem !== null,
        onAddAction: _ctx.addToTarget,
        onRemoveAction: _ctx.removeFromTarget
      }, null, 8, ["can-add", "can-remove", "onAddAction", "onRemoveAction"]),
      _createVNode(_component_setting_panel_kamoku_list, {
        class: "col-5",
        "kamoku-list": _ctx.responseSettingItem.sources,
        "selected-kamoku": _ctx.state.selectedSourceItem,
        onSelectedRow: _ctx.selectedSourceItem
      }, null, 8, ["kamoku-list", "selected-kamoku", "onSelectedRow"])
    ])
  ]))
}